import { api } from '../../domainConfig';
import axiosInstance from '../axiosInstance';

/* eslint no-shadow: ["error", { "allow": ["state"] }] */

const domain = api.userManagementDomain;
const apiKey = api.ApiKey;

const state = {
  loggedInUser: {},
  cachedOrderData: null,
  isLoggedIn: false,
  isLoading: true,
  language: 'en',
};

const getters = {
  getLoggedInUser: (state) => {
    return state.loggedInUser;
  },
  getIsLoggedIn: (state) => {
    return state.isLoggedIn;
  },
  getIsLoading: (state) => {
    return state.isLoading
  },
  getLanguage: (state) => {
    return state.language
  },
}

const mutations = {
  cacheOrderData(state, data) {
    state.cachedOrderData = data;
  },
  UPDATE_LOGGEDIN_USER(state, payload) {
    state.loggedInUser = payload;
  },
  SET_IS_LOGGED_IN(state, payload) {
    state.isLoggedIn = payload;
  },
  SET_IS_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_LANGUAGE(state, payload) {
    state.language = payload
  },
};

let refreshTokenInterval = null;

const actions = {
  async attemptLogin({ commit }, { object }) {
    try {
      const response = await axiosInstance.post(`${domain}/login`, object);
      commit('UPDATE_LOGGEDIN_USER', response.data);
      commit('SET_IS_LOGGED_IN', true)

      // Since Refresh Token is not working, we are not using it
      // dispatch('startRefreshTokenInterval');

      return response.data
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  startRefreshTokenInterval({ dispatch }, router) {
    if (refreshTokenInterval) clearInterval(refreshTokenInterval);

    dispatch('refreshToken', router);
    refreshTokenInterval = setInterval(() => {
      dispatch('refreshToken', router).catch((err) => {
        console.error('Token refresh failed', err);
      });
    }, 900000); // 15 minutes
  },
  stopRefreshTokenInterval() {
    if (refreshTokenInterval) clearInterval(refreshTokenInterval);
  },
  async logoutUser({ commit, dispatch }) {
    commit('UPDATE_LOGGEDIN_USER', {});// Clear logged-in user data
    commit('SET_IS_LOGGED_IN', false)// Set login status to false
    localStorage.removeItem('vuex');
    window.sessionStorage.clear();// Clear session storage
    this.loggedInUser = null;
    dispatch('stopRefreshTokenInterval');
    await dispatch('logoutRequest');// Call the logoutRequest action to handle server-side logout
  },
  async refreshToken({ commit, dispatch }, router) {
    try {
      const response = await axiosInstance.post(`${domain}/refresh-token`, null, {
        headers: {
          'api-key': apiKey,
          Authorization: null,
          // withCredentials: true
        },
      })

      // Retrieve the user object from localStorage
      const user = JSON.parse(localStorage.getItem('vuex'));

      // Update the token within the 'authentication' object
      user.authentication.loggedInUser.token = response.data || null;

      // Save the updated user object back to localStorage
      localStorage.setItem('vuex', JSON.stringify(user));

      commit('UPDATE_LOGGEDIN_USER', user.authentication.loggedInUser);

      return response
    } catch (error) {
      // Dispatch logoutUser to clear the session and logged-in user state
      await dispatch('logoutUser');

      // router.push({ name: 'login' })
      router.push({ path: '/login' })
      throw new Error('Failed to refresh token', error)
    }
  },
  async logoutRequest() {
    try {
      const response = await axiosInstance.post(`${domain}/logout`, {
        headers: {
          'api-key': apiKey,
          Authorization: null,
          // withCredentials: true
        },
      })
      return response
    } catch (error) {
      throw new Error('Failed to logout', error)
    }
  },
  async changePasswordForUser({ commit }, { object, successCallback }) {
    const response = await axiosInstance.put(`${domain}/changePasswordFirstLogin`, object)
    commit('UPDATE_LOGGEDIN_USER', response.data)
    commit('SET_IS_LOGGED_IN', true)
    successCallback();
  },
  test({ commit }) {
    commit('SET_IS_LOGGED_IN', true);
  },
  changeLoadingtoTrue({ commit }, value) {
    commit('SET_IS_LOADING', value)
  },
  changeLanguage({ commit }, lang) {
    commit('SET_LANGUAGE', lang);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
}
